module.exports = __webpack_public_path__ + "media/images/icons/stars-7700edc8dc2a5533bdedfe64e8d1c84e.png";